// A payment is being applied, or has just been applied.
//
// The billing page knows when a payment is being taken and when it has been
// applied; the sidebar's plan card, which is a different tree entirely, has
// no way to hear about it. Rather than lift that state into
// redux for one card, the page announces it and anything that shows plan
// figures can listen.

export const BILLING_BUSY_EVENT = "hostor:billing-busy";

/**
 * @param {boolean} busy true while a payment is being confirmed, false once
 *   it has settled - at which point the allowances have changed and anything
 *   showing them should read them again.
 */
export const emitBillingBusy = (busy) => {
  window.dispatchEvent(
    new CustomEvent(BILLING_BUSY_EVENT, { detail: { busy } }),
  );
};
